import theme from '@app/ui/theme'
import styled from 'styled-components'

export const Content = styled.div`
  flex: 1;
  overflow-y: auto;
  padding: 16px 26px;
`

export const Title = styled.span`
  font-size: 20px;
  font-weight: 600;
`

export const SubTitle = styled.div`
  font-size: 18px;
  font-weight: 500;
  line-height: 28px;
  color: #282828;
`

export const Input = styled.input`
  background: white;
  border: 1px solid #cecece;
  box-sizing: border-box;
  font-size: 16px;
  border-radius: 5px;
  width: 100%;
  height: 40px;
  margin-top: 12px;
  text-indent: 16px;

  &:focus {
    border: 1px solid ${({ theme }) => theme.colors.primary};
    outline: none;
  }

  &::placeholder {
    font-style: normal;
    font-weight: normal;
    font-size: 16px;
    line-height: 19px;
    display: flex;
    align-items: center;
    color: #a5a5a5;
  }
`

export const Source = styled.div`
  display: flex;
  flex-direction: row;
  flex: 1;
  color: black;
  border: 1px solid #ccc;
  background: #f9f9f9;
  box-shadow: 0 0 5px -1px rgba(0, 0, 0, 0.2);
  cursor: pointer;
  vertical-align: middle;
  padding: 8px;
  height: 44px;
  text-align: center;
  align-items: center;

  &:active {
    box-shadow: 0 0 5px -1px rgba(0, 0, 0, 0.6);
    background: #f4f4f4;
  }
`

export const HoleContainer = styled.div<{ isFilled: boolean }>`
  opacity: ${({ isFilled }) => (isFilled ? 1 : 0.5)};
  background-color: #ffffff;
  padding: 8px;
  border: 1px solid #ccc;
  border-radius: 4px;
  display: flex;
  align-items: center;
  flex-direction: row;
`

export const SpinnerContainer = styled.div`
  width: 100%;
  height: 100%;
  display: flex;
  justify-content: center;
  align-items: center;
`

export const SpinnerText = styled.span`
  margin-left: 8;
  position: absolute;
  bottom: 80px;
  font-size: 25px;
`

export const HoleTableContainer = styled.div`
  width: 100%;
  overflow-x: auto;
  margin-bottom: 20px;
`

export const HoleStyledTable = styled.table`
  width: 99%;
  margin-top: 5px;
  border-collapse: collapse;
`

export const HoleTableHead = styled.thead``

export const HoleTableHeaderCell = styled.th`
  font-size: 13px;
  letter-spacing: 1px;
  font-weight: 400;
  color: rgba(0, 0, 0, 0.8);
  border-bottom: 1px solid rgba(0, 0, 0, 0.1);
  padding-bottom: 3px;
  text-align: left;
`

export const HoleTableRow = styled.tr<{ filled: boolean }>`
  opacity: ${({ filled }) => (filled ? 1 : 0.4)};
  &:last-child > * {
    border-bottom: none !important;
  }
`

export const HoleTableCell = styled.td`
  font-size: 16px;
  color: rgba(0,0,0,0.8);
  font-weight: 600;
  text-align: left;
  border-bottom: 1px solid rgba(0, 0, 0, 0.1);
  padding: 5px;
  padding-left: 0;
`

export const CheckContainer = styled.div`
  width: 22px;
  height: 22px;
  border-radius: 50%;
  background-color: ${theme.colors.secondary2};
  display: flex;
  justify-content: center;
  align-items: center;
`
